import * as React from "react"

const Index = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={50}
    height={50}
    {...props}
  >
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="matrix(2.81 0 0 2.81 1.407 1.407)"
    >
      <path
        d="M0-23.964v47.928"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#000",
          fillRule: "nonzero",
          opacity: 1,
        }}
      />
      <path
        d="M45 90a1.01 1.01 0 0 1-1.011-1.011V41.062a1.011 1.011 0 0 1 2.022 0v47.927A1.01 1.01 0 0 1 45 90z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#66676b",
          fillRule: "nonzero",
          opacity: 1,
        }}
      />
      <circle
        cx={45.001}
        cy={20.531}
        r={20.531}
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#f23f38",
          fillRule: "nonzero",
          opacity: 1,
        }}
      />
      <circle
        cx={52.076}
        cy={13.456}
        r={5.056}
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#ff9e9a",
          fillRule: "nonzero",
          opacity: 1,
        }}
      />
    </g>
  </svg>
)
export default Index
